export default __webpack_public_path__ + "static/media/competitions.feff6c5c.webp";